import React, { useState } from 'react';
import Button from '../ui-kit/Button';
import FileAttachmentsModal from '../ui-kit/FileAttachmentsModal';

function ScheduleBlock(props) {
  const [modalOpen, setModalOpen] = useState(false);
  // Ключ модалки фиксируем на значения слота, чтобы React не пересоздавал компонент модалки при ререндере колонки
  const modalKey = `${props.dayOfWeek}__${props.startTime}__${props.endTime}__${props.groupId || props.studentId || ''}`;
  return (
    <div className='ScheduleBlock'>
      <div className="scheduleblock-time">
        {props.startTime} - {props.endTime}
      </div>
      <div className="scheduleblock-subject">
        {props.subject?.name || props.subject}
      </div>
      {props.comment && (
        <div className="scheduleblock-comment">
          {props.comment}
        </div>
      )}
      <Button text="Прикрепить файлы" onClick={() => { window.__slotDate = props.date; setModalOpen(true); }} />
      <FileAttachmentsModal
        key={modalKey}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        week={props.week}
        dayOfWeek={props.dayOfWeek}
        slotIndex={props.slotIndex}
        startTime={props.startTime}
        endTime={props.endTime}
        groupId={props.groupId}
        // studentId только если это индивидуальный слот (нет groupId)
        {...(!props.groupId && props.studentId ? { studentId: props.studentId } : {})}
        showUploader={true}
        readOnly={false}
        currentUserId={props.currentUserId}
        subject={props.subject?._id || props.subject}
      />
    </div>
  );
}

export default ScheduleBlock;